import axios from 'axios'
import { API_URL, APP_TOKEN, LOCALSTORAGE_ACCESS_TOKEN, LOCALSTORAGE_REFRESH_TOKEN  } from '@/api-config';
import router from '../router/index'

const axiosApi = axios.create({
  baseURL: API_URL
});

axiosApi.interceptors.request.use(
  config => {
    const token = localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN);
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    config.headers['x-app-token'] = APP_TOKEN;

    return config
  }
)

// Para evitar loop infinito
let isRefreshing = false;
let refreshSubscribers = [];

// Função para aguardar nova token e reexecutar requisições pendentes
function subscribeTokenRefresh(callback) {
  refreshSubscribers.push(callback);
}

function onRefreshed(newToken) {
  refreshSubscribers.forEach(callback => callback(newToken));
  refreshSubscribers = [];
}

axiosApi.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    // Se 401 (token expirado)
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      originalRequest.url !== '/admin/auth'
    ) {
      originalRequest._retry = true;

      if (isRefreshing) {
        // Já estamos renovando, aguarda a nova token
        return new Promise(resolve => {
          subscribeTokenRefresh(token => {
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            resolve(axiosApi(originalRequest));
          });
        });
      }

      isRefreshing = true;
      const refreshToken = localStorage.getItem(LOCALSTORAGE_REFRESH_TOKEN);

      try {
        const response = await axios.post(`${API_URL}/admin/refresh`, {
          refreshToken
        });

        const newAccessToken = response.data.token;
        const newRefreshToken = response.data.refreshToken;

        // Salvar novos tokens
        localStorage.setItem(LOCALSTORAGE_ACCESS_TOKEN, newAccessToken);
        localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN, newRefreshToken);

        isRefreshing = false;
        onRefreshed(newAccessToken);

        // Reexecutar requisição original com novo token
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
        return axiosApi(originalRequest);
      } catch (err) {
        isRefreshing = false;
        // Refresh token inválido/expirado -> logout
        localStorage.removeItem(LOCALSTORAGE_ACCESS_TOKEN);
        localStorage.removeItem(LOCALSTORAGE_REFRESH_TOKEN);
        router.push('/login');
        return Promise.reject(err);
      }
    }

    // Se 403 (ex.: refresh token inválido direto)
    if (error.response && error.response.status === 403) {
      localStorage.removeItem(LOCALSTORAGE_ACCESS_TOKEN);
      localStorage.removeItem(LOCALSTORAGE_REFRESH_TOKEN);
      router.push('/login');
    }

    return Promise.reject(error);
  }
);

export default axiosApi;